import { Entities } from '../../store';
import { NavigationProjectFeedItem } from '../project-feed/project-feed.model';

export function transformUserRecentProjectsAndContests(
  item: any,
): Entities<NavigationProjectFeedItem> {
  return item.list.map((listItem: any) => ({
    ...listItem,
    urlPart:
      listItem.type === 'project'
        ? `/projects/${listItem.urlPart}`
        : listItem.urlPart,
  }));
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/navigation/recent-projects-and-contests/recent-project-and-contests.transformers.ts